module.exports = __webpack_public_path__ + "static/2-1cb500a031035cc1883c0e9793721e58.jpg";